// NEW: UI_REVAMP
import { Button, Image, Text, useMediaQuery } from '@chakra-ui/react';
import { BALLS } from '../../../constant/bet1';

const Bet1Button = ({ digit, isSelected, onDigitClick, actualColIdx, colIdx, isDisabled }) => {
	const [isTallScreen] = useMediaQuery('(min-height: 813px)');
	const [isShortScreen] = useMediaQuery('(max-height: 780px)');

	let bg = 'rgba(134, 116, 254, 1)';
	let color = 'rgba(246,240,240,1)';
	let boxShadow = '';

	if (isDisabled) {
		bg = 'rgba(218, 212, 255, 1)';
		color = '#AFA2FE';
	} else if (isSelected) {
		bg =
			'radial-gradient(71.44% 43.55% at 11.35% 15%, rgba(107, 222, 235, 0.30) 0%, rgba(149, 207, 255, 0.00) 100%), linear-gradient(180deg, #A4C9EE 0%, #1143E6 100%)';
		boxShadow =
			'1.76px 1.76px 3.521px 0 rgba(255, 255, 255, 0.55) inset, -1.76px -1.76px 3.521px 0 #148EEC inset';
	}

	return (
		<Button
			key={digit}
			position='relative'
			display='flex'
			justifyContent='center'
			alignItems='center'
			p={0}
			maxW='52px'
			maxH='52px'
			h='full'
			minH='0'
			minW='0'
			borderRadius='full'
			bg={bg}
			boxShadow={boxShadow}
			onClick={() => {
				if (isDisabled) return;
				onDigitClick?.(actualColIdx, digit.toString());
			}}
			isDisabled={isDisabled}
			opacity={1}
			_hover={{ bg, boxShadow }}
			_active={{ bg, boxShadow }}
			style={{ aspectRatio: '1 / 1' }}
		>
			{isSelected ? (
				<>
					<Image
						src={`/assets/img/${BALLS[colIdx]}-ball.png`}
						position='absolute'
						top='50%'
						left='50%'
						transform='translate(-50%, -50%)'
						w='78%'
						h='78%'
						objectFit='contain'
						alt='ball'
					/>

					<Text
						position='absolute'
						top='50%'
						left='50%'
						transform='translate(-50%, -50%)'
						zIndex={2}
						fontSize={{ base: isTallScreen ? '14px' : '10px', lg: isShortScreen ? '12px' : '26px' }}
						fontWeight={700}
						color={'rgba(49,3,3,1)'}
					>
						{digit}
					</Text>
				</>
			) : (
				<Text
					fontSize={{ base: isTallScreen ? '24px' : '16px', lg: isShortScreen ? '16px' : '34px' }}
					fontWeight={700}
					color={color}
				>
					{digit}
				</Text>
			)}
		</Button>
	);
};

export default Bet1Button;
